import khushi from "../../assets/khushi.png";
import crystal from "../../assets/crystal.jpg";

export const homeTestimonials = [
  {
    id: 1,
    name: "Khushi",
    quote:
      "EWI felt less like a career fair and more like real conversations. Sitting at dinner with recruiters helped me understand company culture before I ever handed over a resume.",
    image: khushi,
    imageAlt: "Khushi, EWI attendee",
  },
  {
    id: 2,
    name: "Crystal",
    quote:
      "The prep workshops and the evening itself gave me a clear elevator pitch and the confidence to talk to companies I was nervous about approaching.",
    image: crystal,
    imageAlt: "Crystal, EWI attendee",
  },
  /*
  {
    id: 3,
    name: "SWE Member",
    quote:
      "I met representatives from companies I hadn't considered and left with connections that turned into follow-up interviews.",
    image: null,
    imageAlt: "",
  },
  */
];
